/**
 * El dock móvil: abre y cierra las hojas (categorías, cuenta) y el medidor de tallas.
 * SOP: architecture/SOP-inicio.md §4. La hoja la pinta cada enlace (`_aud-dock-enlace`);
 * aquí solo se muestra, se esconde y se devuelve el foco.
 */

const velo = document.querySelector('[data-aud-dock-velo]');
let abierta = null; // { hoja, boton }

function cerrar(devolver = true) {
  if (!abierta) return;
  abierta.hoja.hidden = true;
  abierta.boton.setAttribute('aria-expanded', 'false');
  if (velo) velo.hidden = true;
  if (devolver) abierta.boton.focus({ preventScroll: true });
  abierta = null;
}

function abrir(boton) {
  const hoja = document.getElementById(`aud-dock-hoja-${boton.dataset.audDockHoja}`);
  if (!hoja) return;
  cerrar(false);
  hoja.hidden = false;
  boton.setAttribute('aria-expanded', 'true');
  if (velo) velo.hidden = false;
  abierta = { hoja, boton };
  hoja.querySelector('a, button')?.focus({ preventScroll: true });
}

document.addEventListener('click', (e) => {
  const b = e.target.closest('[data-aud-dock-hoja]');
  if (b) {
    if (abierta && abierta.boton === b) cerrar();
    else abrir(b);
    return;
  }
  if (e.target.closest('[data-aud-dock-cerrar]') || e.target.closest('[data-aud-dock-velo]')) {
    cerrar();
    return;
  }

  /* Un enlace de la hoja la cierra. Hacía falta desde «Mis puntos Audor»: `#smile-home` no
     cambia de página, y sin esto la hoja y su velo se quedaban abiertos debajo del panel de
     Smile. El clic sigue su camino: aquí no se cancela nada. */
  if (abierta && e.target.closest('a') && abierta.hoja.contains(e.target)) {
    cerrar(false);
    return;
  }

  // «Tallas»: abre el medidor de aud-tallas si la página lo tiene; si no, sigue el enlace.
  const m = e.target.closest('[data-aud-medir]');
  if (!m || e.defaultPrevented || !document.getElementById('aud-pop')) return;
  e.preventDefault();
  const gatillo = document.createElement('button');
  gatillo.type = 'button';
  gatillo.hidden = true;
  gatillo.setAttribute('data-aud-medidor', '');
  document.body.appendChild(gatillo);
  gatillo.click();
  gatillo.remove();
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') cerrar();
});
